import get from 'lodash/get';
import {createSelector} from 'reselect';
import {createResourceSelector, createAutoSaveStatusSelector} from 'resources/selectors';

const StatusNamesByKey = {
  pendingSaves: 'isSaving',
  saveErrors: 'error',
  savedField: 'saved'
};

// returns a list of {isSaving, saved, error} objects.
//
// accepts the actual resource as its initial argument, since finding a nested resource
// like a ListicleItem by id would be silly.
export const editRuleAutoSaveSelector = resource => createSelector(
  resources => resources,
  resources => get(resource, 'dynamics', []).map((_, index) => {
    // create a function for finding an auto-save status by matching its key to
    // this dynamic content rule's index.
    const match = key => key.startsWith(`${resource.id}dynamics.${index}`);

    // get pending/saved/error statuses for this dynamic content rule.
    return Object.keys(StatusNamesByKey).reduce((statuses, key) => {
      const name = StatusNamesByKey[key];
      const status = Object.keys(resources[key]).find(match);

      statuses[name] = status;
      return statuses;
    }, {});
  })
);

export const newRuleAutoSaveSelector = resourceId => createSelector(
  resources => resources,
  createAutoSaveStatusSelector(`${resourceId}dynamics.#`)
);



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DynamicContentRules/selectors.js